import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { X } from "@phosphor-icons/react";

/**
 * "Disable MFA" flow. Requires the current password + a fresh 6-digit code.
 * Callers pass `onDisabled` fired after a successful /disable.
 */
export default function MfaDisableFlow({ onDisabled }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ password: "", code: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/mfa/disable", form);
      toast.success("MFA disabled");
      setOpen(false);
      setForm({ password: "", code: "" });
      onDisabled?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} data-testid="mfa-disable-btn"
        className="mt-4 border border-red-600 text-red-700 px-4 py-2 uppercase text-xs tracking-widest font-bold hover:bg-red-600 hover:text-white">
        <X size={12} className="inline mr-1" /> Disable MFA
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="mt-4 border border-black p-4 space-y-3" data-testid="mfa-disable-form">
      <div>
        <label className="label-mono">Current password</label>
        <input data-testid="mfa-disable-password" required type="password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          className="w-full border border-black px-3 py-2 mt-1" />
      </div>
      <div>
        <label className="label-mono">Current 6-digit code</label>
        <input data-testid="mfa-disable-code" required inputMode="numeric" maxLength={6}
          value={form.code}
          onChange={(e) => setForm({ ...form, code: e.target.value.replace(/\D/g, "") })}
          className="w-full border border-black px-3 py-2 mt-1 font-mono" />
      </div>
      <div className="flex gap-2">
        <button type="submit" disabled={busy}
          className="border border-red-600 bg-red-600 text-white px-3 py-2 uppercase text-xs tracking-widest font-bold">
          Disable
        </button>
        <button type="button" onClick={() => setOpen(false)}
          className="border border-black px-3 py-2 uppercase text-xs tracking-widest">
          Cancel
        </button>
      </div>
    </form>
  );
}
